import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import { SvgHome } from '.';

const KuposModal = ({
  showModal,
  onHide,
  size,
  ariaLabel,
  showClose,
  backdrop,
  children
}) => {
  return (
    <div className="common-kupos-modal">
      <Modal
        backdrop={backdrop}
        show={showModal}
        onHide={onHide}
        size={size || 'md'}
        aria-labelledby={'contained-modal-title-vcenter ' + ariaLabel}
        centered
      >
        <Modal.Body>
          <div className="common-kupos-modal-inner">
            {showClose && <div className="close-button pointer" onClick={onHide}>
              <SvgHome name="close" />
            </div>}
            {children}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default KuposModal


// WEBPACK FOOTER //
// ./src/features/common/KuposModal.js